import { jsx } from "react/jsx-runtime";
import BoltIcon from "@mui/icons-material/Bolt";
import { validateTidalLicense } from "../../base/index.js";
function Bolt(props) {
  return /* @__PURE__ */ jsx(
    BoltIcon,
    {
      "data-testid": "Bolt",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Bolt",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
Bolt.tidalIconMeta = {
  categories: "miscellaneous",
  name: "Bolt"
};
validateTidalLicense();
export {
  Bolt
};
//# sourceMappingURL=Bolt.js.map
